import React from 'react';

import * as ROUTES from "../Constants/routes";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Footer() {
    return (
      <div className="footerContainer">
        <footer
          className="page-footer font-small"
          style={{ backgroundColor: "#1C2331" }}
        >
          <div style={{ backgroundColor: "#6351ce" }}>
            <div className="container">
              {/* Grid row*/}
              <div className="row py-4 d-flex align-items-center">
                {/* Grid column */}
                <div className="col-md-6 col-lg-6 text-center text-md-left mb-4 mb-md-0">
                  <h6 className="mb-0">Connect with me!</h6>
                </div>
                {/* Grid column */}
                {/* Grid column */}
                <div className="col-md-6 col-lg-6 text-center text-md-right">
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.reddit.com/user/ComputerCrafter"
                    style={{ color: "black" }}
                  >
                    <FontAwesomeIcon
                      icon={["fab", "reddit"]}
                      size="2x"
                      className="white-text mr-4"
                    />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.youtube.com/channel/UCGg0EiXvSMDQiRhGUzKbbkA?"
                    style={{ color: "black" }}
                  >
                    <FontAwesomeIcon
                      icon={["fab", "youtube"]}
                      size="2x"
                      className="white-text mr-4"
                    />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://github.com/LitMSCTBB"
                    style={{ color: "black" }}
                  >
                    <FontAwesomeIcon
                      icon={["fab", "github"]}
                      size="2x"
                      className="white-text mr-4"
                    />
                  </a>
                </div>
                {/* Grid column */}
              </div>
              {/* Grid row*/}
            </div>
          </div>
          {/* Footer Links */}
          <div className="container text-center text-md-left mt-5">
            {/* Grid row */}
            <div className="row mt-3">
              {/* Grid column */}
              <div
                className="col-md-4 col-lg-4 col-xl-4 mx-auto mb-4"
                align="center"
              >
                {/* Content */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.HOME}>Home</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div
                className="col-md-4 col-lg-4 col-xl-4 mx-auto mb-4"
                align="center"
              >
                {/* Links */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.PUBLICATIONS}>Publications</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div
                className="col-md-4 col-lg-4 col-xl-4 mx-auto mb-md-0 mb-4"
                align="center"
              >
                {/* Links */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.CONTACT}>Contact</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
            </div>
            {/* Grid row */}
          </div>
          {/* Footer Links */}
        </footer>
      </div>
    );
}

export default Footer;